import React from 'react';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import closeIcon from '../../assets/icons/close.svg';

const DetailsPanel = ({ 
  children, 
  onClose, 
  width = '25%', 
  minWidth = '600px',
  backgroundColor = '#F9FAFC',
  showCloseButton = true 
}) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <>
      {/* Background Overlay */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1400,
          cursor: 'pointer',
          touchAction: 'manipulation',
        }}
        onClick={onClose}
        onTouchEnd={(e) => { e.preventDefault(); onClose(); }}
      />
      
      {/* Panel - full width on mobile, desktop unchanged */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: isMobile ? '100%' : width,
          minWidth: isMobile ? 0 : minWidth,
          height: '100vh',
          backgroundColor: backgroundColor,
          boxShadow: '0px 20px 80px #00000011',
          zIndex: 1500,
          overflowY: 'auto',
          padding: isMobile ? '16px' : '20px',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
      {/* Close Button - larger touch target on mobile */}
      {showCloseButton && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <IconButton
            onClick={onClose}
            onTouchEnd={(e) => { e.preventDefault(); onClose(); }}
            sx={{
              padding: 0,
              touchAction: 'manipulation',
              ...(isMobile && {
                padding: '12px',
                minWidth: 48,
                minHeight: 48,
              })
            }}
            aria-label="Fermer"
          >
            <img src={closeIcon} alt="Fermer" style={{ width: '24px', height: '24px' }} />
          </IconButton>
        </Box>
      )}

      {/* Main Content - Takes up available space */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Box>
    </>
  );
};

export default DetailsPanel;
